import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root',
})
export class SubscriptionsHistoryService {
  historyURL = environment.links.subscriptions.ordersHistory;

  constructor(private http: HttpClient) {}

  getOrders(_guiId: string, _offset) {
    const guiId = _guiId;
    const offset = _offset;

    return this.http.get(`${this.historyURL}?guid=${guiId}&offset=${offset}`);
  }
}
